export const statusMap = [
  { label: '正常', value: 1 },
  { label: '删除', value: 2 }
]
